import type { ReactNode } from 'react'

export function EmptyState({
  title,
  body,
  action,
}: {
  title: string
  body?: string
  action?: ReactNode
}) {
  return (
    <div className="carte-admin flex flex-col items-start gap-3 p-8">
      <h2 className="font-titre text-xl text-encre-admin">{title}</h2>
      {body ? <p className="max-w-md text-sm text-second-admin">{body}</p> : null}
      {action}
    </div>
  )
}
